import React, { Component } from "react";
import { Alert, Collapse, Empty, message, Tag } from "antd";
import { RobotOutlined } from "@ant-design/icons";
import axios from "axios";
import { connect } from "react-redux";
import { ModalItem, SwitchItem } from "../../../Components/Items";
import PermisosIaEditor from "./PermisosIaEditor";

const { Panel } = Collapse;

class ModalAccesoIaUsuario extends Component {
  state = {
    loading: false,
    catalogo: null,
    empresas: [],
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) this.cargar();
  }

  cargar = async () => {
    this.setState({ loading: true, empresas: [] });
    try {
      const [catalogo, datos] = await Promise.all([
        this.state.catalogo
          ? Promise.resolve({ data: { success: 2, data: this.state.catalogo } })
          : axios.post("ia/selectCatalogoPermisosIa", {}, { headers: this.props.headersToken }),
        axios.post("ia/datosAccesoIaUsuario", { usuarioId: this.props.usuarioId }, { headers: this.props.headersToken }),
      ]);
      if (catalogo.data.success !== 2 || datos.data.success !== 2) {
        message.error(datos.data.message || catalogo.data.message || "No se pudo consultar el acceso del usuario");
      } else {
        this.setState({ catalogo: catalogo.data.data, empresas: datos.data.data });
      }
    } catch (error) {
      message.error("No se pudo consultar el acceso del usuario");
    }
    this.setState({ loading: false });
  };

  actualizarEmpresa = (empresaId, cambios) =>
    this.setState((prev) => ({
      empresas: prev.empresas.map((e) => (e.empresaId === empresaId ? { ...e, ...cambios } : e)),
    }));

  catalogoDe = (empresa) =>
    (this.state.catalogo || [])
      .map((grupo) => ({
        ...grupo,
        permisos: grupo.permisos.filter((permiso) => !permiso.complemento || empresa.complementos?.[permiso.complemento]),
      }))
      .filter((grupo) => grupo.permisos.length > 0);

  togglePermisos = (empresa, claves, checked) => {
    const actuales = new Set(empresa.permisos);
    claves.forEach((clave) => (checked ? actuales.add(clave) : actuales.delete(clave)));
    const opciones = (this.state.catalogo || []).flatMap((grupo) => grupo.permisos).filter((permiso) => permiso.esOpcion);
    opciones.forEach((opcion) => {
      if (!(opcion.aplicaA || []).some((herramienta) => actuales.has(herramienta.clave))) actuales.delete(opcion._id);
    });
    this.actualizarEmpresa(empresa.empresaId, { permisos: [...actuales] });
  };

  guardar = async () => {
    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "ia/guardarAccesoIaUsuario",
        {
          usuarioId: this.props.usuarioId,
          empresas: this.state.empresas.map(({ empresaId, activo, permisos }) => ({ empresaId, activo, permisos })),
        },
        { headers: this.props.headersToken }
      );
      if (res.data.success === 2) {
        message.success("Acceso a IA guardado");
        this.setState({ loading: false });
        this.props.onCerrar(true);
        return;
      }
      message.error(res.data.message || "No se pudo guardar el acceso a IA");
    } catch (error) {
      message.error("No se pudo guardar el acceso a IA");
    }
    this.setState({ loading: false });
  };

  renderEncabezado = (empresa) => (
    <div style={{ display: "flex", alignItems: "center", gap: 12, width: "100%", flexWrap: "wrap" }}>
      <span onClick={(e) => e.stopPropagation()}>
        <SwitchItem
          checked={empresa.activo}
          disabled={!empresa.tieneAccesoEmpresa}
          onChange={(activo) => this.actualizarEmpresa(empresa.empresaId, { activo })}
        />
      </span>
      <div style={{ display: "flex", flexDirection: "column", flex: 1, minWidth: 160 }}>
        <span style={{ fontWeight: 600, color: "#1a3a4a" }}>{empresa.nombre}</span>
        <span style={{ fontSize: 12, color: "#888" }}>{empresa.rfc}</span>
      </div>
      <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
        {!empresa.tieneAccesoEmpresa && <Tag style={{ margin: 0 }}>Sin acceso a la empresa</Tag>}
        {empresa.tieneAccesoEmpresa && empresa.activo && empresa.permisos.length === 0 && (
          <Tag color="orange" style={{ margin: 0 }}>Sin funciones</Tag>
        )}
        {empresa.tieneAccesoEmpresa && empresa.activo && empresa.permisos.length > 0 && (
          <Tag color="cyan" style={{ margin: 0 }}>
            {empresa.permisos.length} {empresa.permisos.length === 1 ? "función" : "funciones"}
          </Tag>
        )}
        {!empresa.avisoAceptado && <Tag color="red" style={{ margin: 0 }}>Aviso pendiente</Tag>}
      </div>
    </div>
  );

  renderContenido = (empresa) => {
    if (!empresa.tieneAccesoEmpresa) {
      return (
        <Alert
          type="info"
          showIcon
          message="El usuario no tiene proyectos asignados en esta empresa. Asígnale uno en Usuarios › Acceso a proyectos para poder darle acceso a la IA aquí."
        />
      );
    }
    return (
      <>
        {!empresa.avisoAceptado && (
          <Alert
            type="warning"
            showIcon
            style={{ marginBottom: 10 }}
            message="Mientras no aceptes el aviso de uso de IA de esta empresa, nadie podrá usar la IA en ella."
          />
        )}
        {empresa.activo ? (
          <PermisosIaEditor
            catalogo={this.catalogoDe(empresa)}
            seleccionados={empresa.permisos}
            onToggle={(claves, checked) => this.togglePermisos(empresa, claves, checked)}
          />
        ) : (
          <Alert type="info" showIcon message="Activa el acceso a la IA en esta empresa para asignarle funciones." />
        )}
      </>
    );
  };

  render() {
    return (
      <ModalItem
        title={
          <span>
            <RobotOutlined style={{ marginRight: 8 }} />
            Acceso a IA {this.props.usuarioNombre ? `- ${this.props.usuarioNombre}` : ""}
          </span>
        }
        visible={this.props.visible}
        spinning={this.state.loading}
        onCancel={() => this.props.onCerrar(false)}
        onOk={this.guardar}
        footer
        okText="Guardar"
        paddingTop
      >
        <Alert
          type="info"
          showIcon
          style={{ marginBottom: 12, borderRadius: 8 }}
          message="Las funciones que actives en cada empresa son las únicas que este usuario podrá usar cuando inicie sesión desde su asistente de IA (Claude, ChatGPT, etc.). Las marcadas como Opción no aparecen como herramienta en el asistente: amplían lo que pueden hacer las herramientas a las que se agregan."
        />
        {this.state.empresas.length === 0 && !this.state.loading ? (
          <Empty description="No hay empresas con la IA activada" />
        ) : (
          <Collapse bordered={false} expandIconPosition="right" style={{ background: "transparent" }}>
            {this.state.empresas.map((empresa) => (
              <Panel
                key={empresa.empresaId}
                header={this.renderEncabezado(empresa)}
                style={{
                  marginBottom: 12,
                  borderRadius: 12,
                  overflow: "hidden",
                  background: "#fff",
                  border: "1px solid rgb(235, 237, 240)",
                  borderLeft: `4px solid ${empresa.activo ? "#00BFD6" : "#d9d9d9"}`,
                  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.05)",
                }}
              >
                {this.renderContenido(empresa)}
              </Panel>
            ))}
          </Collapse>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
});

export default connect(mapStateToProps)(ModalAccesoIaUsuario);
